import { useCallback } from "react";
import PromotionCardGroupContainer from "../vas/promotionCard/PromotionCardGroupContainer";
import ChartContainer from "../vas/chart/ChartContainer";
import ComboPackageGroupContainer from "../vas/comboPackageGroup/ComboPackageGroupContainer";
import TextualSeparatorContainer from "../vas/textualSeparator/TextualSeparatorContainer";
import DiscountContainer from "../vas/discount/DiscountContainer";
import Header from "../vas/Header/Header";
import InfoHeader from "../vas/infoHeader/InfoHeader";
import { Widget } from "../interfaces";
import BundlePackageGroupContainer from "../vas/bundlePackageGroup/BundlePackageGroupContainer";
import ScrollableCardGroupContainer from "../vas/scrollableCardGroup/ScrollableCardGroupContainer";
import ButtonGroupContainer from "../vas/buttonGroup/ButtonGroupContainer";
import PayPerListingPackageContainer from "../vas/payPerListingPackage/PayPerListingPackageContainer";
import FinalizeButton from "../vas/finalizeButton/FinalizeButton";
import PromotionTabContainer from "../vas/promotionTab/PromotionTabContainer";
import PromotionCardSliceContainer from "../vas/promotionCardSlice/PromotionCardSliceContainer";
import BenefitsContainer from "../vas/benefits/BenefitsContainer";
import SkipContinueButton from "../vas/skipContinueButton/SkipContinueButton";
import ListingAddonCardContainer from "../vas/listingAddonCard/ListingAddonCardContainer";
import ContinueButton from "../vas/continueButton/ContinueButton";
import TextLineContainer from "../vas/textLine/TextLineContainer";
import InnerButtonContainer from "../vas/innerButton/InnerButtonContainer";
import HeaderGroup from "../vas/headerGroup/HeaderGroup";
import PromotionGroup from "../vas/promotionGroup/PromotionGroup";
import BenefitGroup from "../vas/benefitGroup/BenefitGroup";
import ExtendGroup from "../vas/extendGroup/ExtendGroup";
import AddonGroup from "../vas/addonGroup/AddonGroup";
import InnerButtonGroup from "../vas/innerButtonGroup/InnerButtonGroup";
import InfoCard from "../vas/infoCard/InfoCard";
import ButtonWebGroup from "../vas/buttonWebGroup/ButtonWebGroup";
import BundleWebGroup from "../vas/bundleWebGroups/BundleWebGroup";

const Mapper = ({ widget }: { widget: Widget }) => {
  const { items, type, scroll } = widget;
  const selectedComp: () => JSX.Element = useCallback(() => {
    switch (type) {
      case "header":
        return <Header items={items} />;
      case "infoHeader":
        return <InfoHeader items={items} />;
      case "scrollableCardGroup":
        return <ScrollableCardGroupContainer items={items} scroll={scroll} />;
      case "promotionCard":
        return <PromotionCardGroupContainer items={items} />;
      case "listingAddonCard":
        return <ListingAddonCardContainer items={items} />;
      case "meter":
        return <ChartContainer items={items} />;
      case "comboPackage":
        return <ComboPackageGroupContainer items={items} scroll={scroll} />;
      case "textualSeparator":
        return <TextualSeparatorContainer items={items} />;
      case "bundlePackageGroup":
        return <BundlePackageGroupContainer items={items} scroll={scroll} />;
      case "finalizeButton":
        return <FinalizeButton items={items} />;
      case "discountPill":
        return <DiscountContainer items={items} />;
      case "buttonGroup":
        return <ButtonGroupContainer items={items} />;
      case "payPerListingPackage":
        return <PayPerListingPackageContainer items={items} />;
      case "promotionTab":
        return <PromotionTabContainer items={items}/>;
      case "promotionCardSlice":
        return <PromotionCardSliceContainer items={items}/>;
      case "benefits":
        return <BenefitsContainer items={items}/>;
      case "textLine":
        return <TextLineContainer items={items}/>;
      case "skipContinueButton":
        return <SkipContinueButton items={items} />;
      case "continueButton":
        return <ContinueButton items={items}/>;
      case "innerButton":
        return <InnerButtonContainer items={items} />;
      case "headerGroup":
        return <HeaderGroup items={items}/>;
      case "promotionGroup":
        return <PromotionGroup items={items}/>;
      case "benefitGroup":
        return <BenefitGroup items={items}/>
      case "bundleWebGroup":
        return <BundleWebGroup items={items}/>
      case "extendGroup":
        return <ExtendGroup items={items}/>
      case "addonGroup":
        return <AddonGroup items={items}/>
      case "innerButtonGroup":
        return <InnerButtonGroup items={items}/>
      case "infoCard":
        return <InfoCard items={items} />
      case "buttonWebGroup":
        return <ButtonWebGroup items={items}/>
        // case "sticky":
      //   return <StickyButton />;
      default:
        return <></>;
    }
  }, [items, type, scroll]);
  return selectedComp();
};

export default Mapper;
